import { useMemo } from 'react';
import { makeSearchAddressFunc } from 'helper/address-search';
import { useSelector } from 'react-redux';
import {
  isPaxSelector,
  selectedCitySelector,
  userCompanySelector,
} from 'selectors/app-selector';

export const useOverlayLayout = () =>
  useMemo(() => {
    if (window.innerWidth < 932) {
      return { width: '100%', placement: 'bottom' };
    }
    return { width: 495, placement: 'right' };
  }, []);

export const useFetchSearchAddressFunc = ({ isPickUp = false }) => {
  const isPax = useSelector(isPaxSelector);
  const city = useSelector(selectedCitySelector);
  const company = useSelector(userCompanySelector);
  return useMemo(
    () =>
      makeSearchAddressFunc({
        isPax,
        city,
        company,
        isPickUp,
      }),
    [isPax, city, company, isPickUp],
  );
};

export default {};
